import { Cookies } from "../../../utils/functions";
import { AuthStateProps } from "../../../utils/types/redux/auth";
import {
  InitLocationAuthProps,
  AuthActionTypes,
} from "../../../utils/types/redux/auth";
import { COOKIES } from "../../../utils/constants";

// ACTION TYPES

const USER_LOADED = "auth/USER_LOADED";
const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
const LOGIN_SUCCESS_NO_REMIND = "auth/LOGIN_SUCCESS_NO_REMIND";
const LOGIN_FAIL = "auth/LOGIN_FAIL";
const CLEAR_ERRORS = "auth/CLEAR_ERRORS";
const AUTH_ERROR = "auth/AUTH_ERROR";
const SET_INIT_LOCATION = "auth/SET_INIT_LOCATION";

// REDUCER

const initialState: AuthStateProps = {
  token: (Cookies.get(COOKIES.SESSION.NAME) as { authToken: string })
    ?.authToken,
  isAuthenticated: false,
  user: null,
  error: null,
  initLocation: null,
};

const reducer = (state = initialState, action: any): AuthStateProps => {
  switch (action.type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload,
        isAuthenticated: true,
      };

    case LOGIN_SUCCESS_NO_REMIND:
      return {
        ...state,
        token: action.payload,
        isAuthenticated: true,
      };

    case AUTH_ERROR:
    case LOGIN_FAIL:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    case SET_INIT_LOCATION:
      return {
        ...state,
        initLocation: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;

// ACTION CREATORS

export const setUserLoaded = (userData: any): AuthActionTypes => ({
  type: USER_LOADED,
  payload: userData,
});

export const setLoadSuccess = (token: string): AuthActionTypes => ({
  type: LOGIN_SUCCESS,
  payload: token,
});

export const setLoadSuccessNoRemindUser = (token: string): AuthActionTypes => ({
  type: LOGIN_SUCCESS_NO_REMIND,
  payload: token,
});

export const authError = (msg: string): AuthActionTypes => ({
  type: AUTH_ERROR,
  payload: msg,
});

export const clearErrors = (): AuthActionTypes => ({ type: CLEAR_ERRORS });

export const setInitLocation = (
  payload?: InitLocationAuthProps,
): AuthActionTypes => ({
  type: SET_INIT_LOCATION,
  payload,
});
